export default function togglePasswordFieldType(fields) {
  if (fields && fields.length) {
    fields.forEach(field => {
      let passwordToggleButton = field.querySelector('.js-toggle-password-visibility');
      if (passwordToggleButton) {
        passwordToggleButton.addEventListener('click', (event) => {
          let input = event.target.parentNode.querySelector('input');
          if (input.getAttribute('type') === 'password') {
            input.setAttribute('type', 'text');
            event.target.classList.add('passwordVisible');
          } else {
            input.setAttribute('type', 'password');
            event.target.classList.remove('passwordVisible');
          }
        });
      }
    });
  }
}


// WEBPACK FOOTER //
// ./src/js/toggle-password-field-type.js